module.exports = __webpack_public_path__ + "img/item6-3.d38c27b1.png";